export const RESET_STATE_RIKJANG = {
  id_jenis_rikjang: 1,
  id_tarif_cbg: null,
  tarif_cbg: "Pilih CBG",
  nama: "",
  gudang_id: null,
  gudang_name: "Pilih Gudang",
  harga: "",
  status: 1,
  isUpdate: false,
  barang: [],
  jasa: [],
  fasilitas: [],
};

export const RESET_TAB_MODAL = {
  id: "",
  item_id: "",
  name: "",
  qty: 1,
};

export const RESET_STATE_FORM_FILTER = {
  id_jenis_harga: "",
  pages: 1,
  limit: 10,

  nama: "",
  id: "",
};

export const ITEM_TYPE_BARANG = 1;
export const ITEM_TYPE_JASA = 2;
export const ITEM_TYPE_FASILITAS = 3;
export const ITEM_TYPE_RIKJANG = 4;

export const urlCreate = "/master/rikjang/ms_rikjang/add";
export const urlUpdate = "/master/rikjang/ms_rikjang/updateHarga";
export const urlDelete = "/master/rikjang/ms_rikjang/delete";

export const urlGet = "/master/rikjang/ms_rikjang/list";
export const urlAddItem = "/master/rikjang/ms_rikjang/addItem";
export const urlDeleteItem = "/master/rikjang/ms_rikjang/deleteItem";

export const urlAddItemPaket = "/master/paket/ms_paket/addItem";
export const urlDeleteItemPaket = "/master/paket/ms_paket/deleteItem";

export const urlGetById = "/master/rikjang/ms_rikjang/detailsById";
export const urlUpdateAll = "/master/rikjang/ms_rikjang/updateAll";

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
];
